import React  from 'react';
import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { MyButton } from '../common/components';
import MyPaperComponent from '../common/components/MyPaperComponent';
import CustomDialog from '../common/components/CustomDialog';
import ReferralDocuments from '../referral/documentUploads/ReferralDocuments';

export default function UploadReferralDocuments({
  uuid,
  open,
  setOpenDialog,
  isFax = false,
}) {

  return (
    <CustomDialog
      open={open}
      onClose={() => {
        setOpenDialog(false);
      }}
      PaperComponent={MyPaperComponent}
      style={{ minWidth: '800px' }}
    >
      <DialogTitle>
        {isFax ? 'Upload New Documents to Fax' : 'Upload Documents'}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ width: '100%' }}>
          <ReferralDocuments referralUuid={uuid} isSameOrg={true} inDialog={true} />
        </Box>
      </DialogContent>
      <DialogActions>
        <MyButton
          color="error"
          variant="contained"
          onClick={() => {
            setOpenDialog(false);
          }}
          fullWidth={false}
        >
          {isFax ? 'Cancel' : 'Done'}
        </MyButton>
      </DialogActions>
    </CustomDialog>
  );
}
